import { render, staticRenderFns } from "./ufiche.vue?vue&type=template&id=1bedfe1b&"
import script from "./ufiche.vue?vue&type=script&lang=js&"
export * from "./ufiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports